var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "v-upload" }, [
    _c(
      "form",
      {
        ref: "iform",
        staticClass: "iform",
        attrs: {
          method: "POST",
          action: _vm.action,
          target: _vm.targetFile,
          enctype: "multipart/form-data",
        },
      },
      [
        _vm._l(_vm.data, function (value, name) {
          return _c("input", {
            key: value,
            attrs: { type: "hidden", name: name },
            domProps: { value: value },
          })
        }),
        _vm.type !== "picture"
          ? _c(
              "div",
              [
                _c(
                  "v-button",
                  {
                    staticClass: "v-upload__button",
                    attrs: { icon: "v-icon-upload", disabled: _vm.disabled },
                    on: { click: _vm.clickFile },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm._("Choose File")))])]
                ),
              ],
              1
            )
          : _c("upload-image", {
              ref: "image",
              attrs: {
                disabled: _vm.disabled,
                "upload-type": _vm.uploadType,
                "data-image": _vm.imageBase64,
              },
              on: { clickFile: _vm.clickFile },
            }),
        _vm.fileName && _vm.showFileList
          ? _c(
              "div",
              {
                staticClass: "v-upload__tips",
                class: { "v-upload__tips--center": _vm.type === "picture" },
              },
              [
                _c("span", { staticClass: "v-upload-tips" }, [
                  _vm._v(_vm._s(_vm.fileName)),
                ]),
              ]
            )
          : _vm._e(),
        !_vm.disabled
          ? _c("input", {
              ref: "file",
              staticClass: "v-upload__file",
              attrs: { name: _vm.name, type: "file", accept: _vm.acceptType },
              on: { change: _vm.selectFile },
            })
          : _vm._e(),
      ],
      2
    ),
    _c("iframe", {
      ref: "upload",
      staticClass: "v-upload__iframe",
      attrs: { name: _vm.targetFile, width: "1px", height: "1px" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }